var _path, _circle, _circle2, _path2, _rect, _line, _line2, _line3, _text, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPurchasing(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3 3 L5 3 L7 17 H19 L21 7 H6",
    fill: "none",
    stroke: "currentColor",
    strokeWidth: 1.5
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 9,
    cy: 20,
    r: 2,
    fill: "none",
    stroke: "currentColor",
    strokeWidth: 1.5
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 17,
    cy: 20,
    r: 2,
    fill: "none",
    stroke: "currentColor",
    strokeWidth: 1.5
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7 7 L5 3",
    fill: "none",
    stroke: "currentColor",
    strokeWidth: 1.5
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 14,
    y: 4,
    width: 8,
    height: 10,
    fill: "none",
    stroke: "currentColor",
    strokeWidth: 1.5
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 16,
    y1: 7,
    x2: 20,
    y2: 7,
    stroke: "currentColor",
    strokeWidth: 1
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    x1: 16,
    y1: 9,
    x2: 20,
    y2: 9,
    stroke: "currentColor",
    strokeWidth: 1
  })), _line3 || (_line3 = /*#__PURE__*/React.createElement("line", {
    x1: 16,
    y1: 11,
    x2: 18,
    y2: 11,
    stroke: "currentColor",
    strokeWidth: 1
  })), _text || (_text = /*#__PURE__*/React.createElement("text", {
    x: 12,
    y: 6,
    textAnchor: "middle",
    fontSize: 10,
    fill: "currentColor",
    opacity: 0.8
  }, "$")), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M16 13 L18 15 L20 13",
    stroke: "currentColor",
    strokeWidth: 1.5,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPurchasing);
export default __webpack_public_path__ + "static/media/purchasing.72043b2ee3859357df57f44c8896a747.svg";
export { ForwardRef as ReactComponent };